"use strict";

exports.__esModule = true;
exports.termsOfServiceRoute = termsOfServiceRoute;
exports.TermsOfServiceSeoMetadata = exports.TermsOfServiceMetadata = exports.TermsOfServiceTitle = exports.TermsOfServicePath = exports.TermsOfServiceSegment = void 0;

var _getPath = require("../../route/getPath");

var _createRoute = require("../../route/createRoute");

var TermsOfServiceSegment = "tos";
exports.TermsOfServiceSegment = TermsOfServiceSegment;
var TermsOfServicePath = (0, _getPath.getPath)(TermsOfServiceSegment);
exports.TermsOfServicePath = TermsOfServicePath;
var TermsOfServiceTitle = "Terms of Service";
exports.TermsOfServiceTitle = TermsOfServiceTitle;
var TermsOfServiceMetadata = {
  noindex: true,
  follow: true
};
exports.TermsOfServiceMetadata = TermsOfServiceMetadata;
var TermsOfServiceSeoMetadata = {
  robots: TermsOfServiceMetadata
};
exports.TermsOfServiceSeoMetadata = TermsOfServiceSeoMetadata;

function termsOfServiceRoute(rootPath) {
  var route = (0, _createRoute.createRoute)(rootPath, TermsOfServicePath);

  route.getData = function () {
    return {
      path: TermsOfServicePath
    };
  };

  route.noindex = TermsOfServiceMetadata.noindex;
  return route;
}